<template>
  <div id="xhs">
    <el-menu :default-active="'1'" mode="horizontal" background-color="#31323a" text-color="#fff"
             active-text-color="#409EFF" router="true">
      <el-menu-item style="width: 25%; text-align:center;" index="1" :route="{ path: '/xhs_zhaomu' }">
        小红书
      </el-menu-item>
      <el-menu-item style="width: 25%; text-align:center;" index="2" :route="{ path: '/dy_zhaomu' }">
        抖音
      </el-menu-item>
<!--      <el-menu-item style="width: 25%; text-align:center;" index="3" :route="{ path: '/dp_zhaomu' }">-->
<!--        大众点评-->
<!--      </el-menu-item>-->
<!--      <el-menu-item style="width: 25%; text-align:center;" index="4" :route="{ path: '/dw_zhaomu' }">-->
<!--        得物-->
<!--      </el-menu-item>-->
      <el-menu-item style="width: 25%; text-align:center;" index="5" :route="{ path: '/wb_zhaomu' }">
        微博
      </el-menu-item>
      <el-menu-item style="width: 25%; text-align:center;" index="6" :route="{ path: '/bb_zhaomu' }">
        B站
      </el-menu-item>
    </el-menu>
    <div class="line"></div>
    <router-view/>

    <div class="header" style="background-color: #31323a; height: 50px; line-height: 50px; margin-bottom: 10px;">
      <div class="h_headline" style="text-align:center; color:#FFFFFF; line-height: 1.4;">
        <img src="https://imgsrc.baidu.com/forum/pic/item/e850352ac65c10387b59cf7eb7119313b07e8962.jpg"
             style="float: left; width: 30px; height: 30px; margin: 10px;">
        <div style="float: left; font-size: 24px; font-weight: 700; height: 50px; line-height: 50px;">小红书APP-达人报名</div>
      </div>
    </div>

    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="红书链接">
        <el-input v-model="form.xhs_url" placeholder="请填写小红书个人主页链接"></el-input>
      </el-form-item>
      <el-form-item label="微信号">
        <el-input v-model="form.xhs_wechat" placeholder="请填写微信号"></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="form.xhs_phone" placeholder="请填写手机号"></el-input>
      </el-form-item>
      <el-form-item label="所属领域">
        <el-select v-model="form.xhs_category">
          <el-option label="美妆个护" value="美妆个护"></el-option>
          <el-option label="母婴亲子" value="母婴亲子"></el-option>
          <el-option label="服饰穿搭" value="服饰穿搭"></el-option>
          <el-option label="家居家装" value="家居家装"></el-option>
          <el-option label="探店出行" value="探店出行"></el-option>
          <el-option label="运动健身" value="运动健身"></el-option>
          <el-option label="健康养生" value="健康养生"></el-option>
          <el-option label="美食分享" value="美食分享"></el-option>
          <el-option label="宠物日常" value="宠物日常"></el-option>
          <el-option label="教育培训" value="教育培训"></el-option>
          <el-option label="商业财经" value="商业财经"></el-option>
          <el-option label="兴趣爱好" value="兴趣爱好"></el-option>
          <el-option label="科技数码" value="科技数码"></el-option>
          <el-option label="生活记录" value="生活记录"></el-option>
          <el-option label="搞笑娱乐" value="搞笑娱乐"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="图文报价">
        <el-input v-model="form.xhs_image_price" placeholder="请填写图文报价(不走蒲公英，单位元)"></el-input>
      </el-form-item>
      <el-form-item label="视频报价">
        <el-input v-model="form.xhs_video_price" placeholder="请填写视频报价(不走蒲公英，单位元)"></el-input>
      </el-form-item>
      <el-form-item label="其它平台">
<!--        <el-checkbox-group v-model="form.xhs_platform">-->
<!--          <el-checkbox label="有抖音" name="type"></el-checkbox>-->
<!--&lt;!&ndash;          <el-checkbox label="有快手" name="type"></el-checkbox>&ndash;&gt;-->
<!--&lt;!&ndash;          <el-checkbox label="有得物" name="type"></el-checkbox>&ndash;&gt;-->
<!--          <el-checkbox label="有微博" name="type"></el-checkbox>-->
<!--          <el-checkbox label="有B站" name="type"></el-checkbox>-->
<!--        </el-checkbox-group>-->
        <el-row>
          <el-button size="mini" round>
            <a :href="'/#/dy_zhaomu'" rel="external nofollow"  target="_self" style="text-decoration: none">
              报名抖音
            </a>
          </el-button>
          <el-button size="mini" round>
            <a :href="'/#/wb_zhaomu'" rel="external nofollow"  target="_self" style="text-decoration: none">
              报名微博
            </a>
          </el-button>
          <el-button size="mini" round>
            <a :href="'/#/bb_zhaomu'" rel="external nofollow"  target="_self" style="text-decoration: none">
              报名B站
            </a>
          </el-button>
        </el-row>
      </el-form-item>
      <el-button type="primary" @click="onSubmit" style="width: 100%; background-color: #31323a;">立即提交</el-button>
    </el-form>

    <div id="m_input" style="position: relative; text-align: center; font-size: 16px; height: auto; margin-top: 20px;"> 提交后，请加PR微信:
      <span style="color: #ff0000; font-size: 20px; font-weight: bold;">maozhou2023</span>
    </div>

    <div style="margin-top: 10px">
      <el-image src="/static/maoapp/images/maoyan_pr_wx_2.jpg"></el-image>
    </div>

    <el-dialog title="操作提示"  width="80%" :visible.sync="dialogVisible" :center="true" :show-close="false">
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">知道了</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import process from "shelljs";

  export default {
    name: 'xhs',
    data() {
      return {
        form: {
          xhs_url: '',
          xhs_wechat:'',
          xhs_phone:'',
          xhs_category: '',
          xhs_platform: [],
          xhs_image_price: '',
          xhs_video_price: '',
          xhs_come_from: ''
        },
        dialogMsg: '',
        dialogVisible: false,
      }
    },
    created() {
      this.form.xhs_come_from = this.$route.query.come_from;
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      onSubmit() {
        let base = '/api'
        if (process.env.NODE_ENV === "development") {
          base = 'http://api.wushangxianzhi.com'
        }
        let url = '/api/v2/maoapp/zhaomu_vue_xhs'
        this.$axios({
          method:'post',
          headers: {
            'content-type': 'application/x-www-form-urlencoded', // 注释1
          },
          url: `${base}${url}`,
          data:this.form,
        }).then((response) =>{          //这里使用了ES6的语法
          // alert(response.data.msg)
          this.dialogMsg = response.data.msg
          this.dialogVisible = true
          console.log(response.data)      //请求成功返回的数据
        }).catch((error) => {
          alert(error)
          console.log(error)      //请求失败返回的数据
        })
      }
    },
    metaInfo: {
      title: "袤-达人招募",
      meta: [
        { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
        { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
        { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
        { name: "format-detection", content: "telephone=no,email=no" }
      ],
      link: [{
        rel: 'shortcut icon',
        href: '/static/favicon.ico'
      }]
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/zhaomu/XiaoHongShu.vue